import * as DG from "ui/dialogs"
import { ChangeEvent, useEffect, useState } from "react"

import { queryCache, useMutation } from "react-query"

import Button from "ui/buttons/Button"
import { Channel } from "../../types"
import { TextInput } from "components/inputs/TextInput"
import { updateVendorChannel } from "api/suppliers"
import { useI18n } from "providers/I18n"
import { css } from "@emotion/css"
import { useSendFeedBack } from "components/FeedbackSnackbar"

type Props = {
  open: boolean
  onClose: () => void
  mediaTypeId: string
  channel?: Channel
}

export function UpdatePackageModal(props: Props) {
  const { open, onClose, channel } = props
  const { t } = useI18n()
  const feedback = useSendFeedBack()
  const [name, setName] = useState<string | undefined>(channel?.name)

  const formId = "create-new-product-dialog"

  const [patch] = useMutation(updateVendorChannel, {
    onSuccess: () => {
      queryCache.invalidateQueries("media-types-channels")
      setName(undefined)
      onClose()
    },
    onError: (e) =>
      feedback(
        t(e.message) || t("vendors.vendorProduct.update.error"),
        "error",
      ),
  })

  const handleChange = (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement> | undefined,
  ) => {
    setName(event?.target.value)
  }

  const handleUpdate = () => {
    if (!!name && !!channel?.id) {
      const pld = {
        channelId: channel?.id,
        name,
        electronicOrderingActive: channel?.electronicOrderingActive || false,
      }

      patch(pld)
    }
  }

  useEffect(() => {
    !!channel?.name && setName(channel?.name)
  }, [channel])

  return (
    <DG.Dialog
      fullWidth={false}
      open={open}
      onClose={onClose}
      id={formId}
      classes={{ paperWidthSm: styles.wrapper }}
    >
      <>
        <DG.DialogHeader>
          <DG.DialogTitle id={formId}>{t("product.update")}</DG.DialogTitle>
          <DG.DialogClose onClose={onClose} />
        </DG.DialogHeader>

        <DG.DialogContent center paddingTop>
          <TextInput
            label={t("products.name.input")}
            variant="outlined"
            onChange={handleChange}
            value={name}
          />
        </DG.DialogContent>
        <DG.DialogFooter>
          <DG.DialogActions>
            <Button variant="outlined" color="primary" onClick={onClose}>
              {t("campaign.button.cancel")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={handleUpdate}
            >
              {t("campaign.button.update")}
            </Button>
          </DG.DialogActions>
        </DG.DialogFooter>
      </>
    </DG.Dialog>
  )
}

const styles = {
  wrapper: css`
    min-width: 300px;
  `,
}
